<div [ngClass]="optionsValue().cssClasses.pagingContainer">
    <div [ngClass]="optionsValue().cssClasses.pagingElement">
        @for(page of pages(); track page)
        {
            <a (click)="setPageItem(page)" [ngClass]="{disabled: page.isDisabled, active: page.isActive}">
                <span [innerHtml]="page.title"></span>
            </a>
        }
    </div>

    <div [ngClass]="optionsValue().cssClasses.pagingSeparatorElement"></div>

    @if(itemsPerPageItems().length)
    {
        <div [ngClass]="optionsValue().cssClasses.itemsPerPageContainer">
            <div [ngClass]="optionsValue().cssClasses.itemsCountElement">{{displayedItemsCount()}}</div>

            <div [ngClass]="optionsValue().cssClasses.itemsPerPageElement">
                @for (itemsPerPage of itemsPerPageItems(); track itemsPerPage)
                {
                    <a (click)="setItemsPerPageItem(itemsPerPage)" [ngClass]="{active: itemsPerPage.isActive}">
                        <span [innerHtml]="itemsPerPage.value | infinityNaN"></span>
                    </a>
                }
            </div>
        </div>
    }
</div>